import React, { useState, useEffect } from "react";
import { Card, Form } from "react-bootstrap";
import ErrorComponent from "../../../Components/ErrorMessage";

import { replacePlaceholder } from "../../../Utils/Utils";
import MobileMatrixMultiOptionQuestion from "./MobileMultiMatrixOption";

const MatrixMultiOptionQuestionCard = ({ question, formValues, setFormValues, showError }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const questionText = replacePlaceholder(question.questionText, formValues);

  const getFlatValues = () => {
    const flatValues = {};
    const matrixValues = formValues[question.tempId] || [];

    matrixValues.forEach(rowObj => {
      const rowKey = Object.keys(rowObj)[0];
      flatValues[rowKey] = rowObj[rowKey];
    });

    return flatValues;
  };

  const flatValues = getFlatValues();

  const hasAnswer = Object.keys(flatValues).some(
    key => flatValues[key].some(value => value !== "")
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSelectChange = (e, rowIndex, colIndex) => {
    const value = e.target.value;
    const rowKey = `${question.tempId}_r${rowIndex + 1}`;

    setFormValues(prev => {
      const currentAnswers = prev[question.tempId] || [];
      const rowAnswer = currentAnswers.find(a => a[rowKey]) || { [rowKey]: Array(question.columns.length).fill("") };

      const updatedRowValues = [...rowAnswer[rowKey]];
      updatedRowValues[colIndex] = value;

      return {
        ...prev,
        [question.tempId]: [
          ...currentAnswers.filter(a => !a[rowKey]),
          { [rowKey]: updatedRowValues }
        ]
      };
    });
  };

  if (isMobile) {
    return (
      <MobileMatrixMultiOptionQuestion
        question={question}
        formValues={formValues}
        handleSelectChange={handleSelectChange}
        showError={showError}
      />
    );
  }

  return (
    <Card className={`mt-3 ${question.isMandatory && showError && !hasAnswer ? "border-danger" : ""}`}>
      <Card.Body>
        <Form>
          <Form.Group>
            <div className="d-flex flex-column">
              <Form.Label>
                <b style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {question.tempId}.{questionText}
                  {question.isMandatory && <span className="text-danger">*</span>}
                </b>
              </Form.Label>
              <Form.Label>
                <b style={{ color: 'lightblue' }}>{question.questionDescription}</b>
              </Form.Label>
              {question.isMandatory && showError && !hasAnswer && (
                <ErrorComponent message={question.requiredErrorText} />
              )}
            </div>

            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th></th>
                    {question.columns.map((column, index) => (
                      <th key={index}>{column}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {question.rows.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td>{row}</td>
                      {question.columns.map((col, colIndex) => (
                        <td key={colIndex}>
                          <Form.Select
                            id={`${question.tempId}_${rowIndex}_${colIndex}`}
                            value={flatValues[`${question.tempId}_r${rowIndex + 1}`]?.[colIndex] || ""}
                            onChange={(e) => handleSelectChange(e, rowIndex, colIndex)}
                          >
                            <option value="">Select</option>
                            {question.cellOptions.map((option, i) => (
                              <option key={i} value={option}>
                                {option}
                              </option>
                            ))}
                          </Form.Select>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Form.Group>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default MatrixMultiOptionQuestionCard;
